<p
  dir="auto"
  class="wrap-text"
  [innerHTML]="localMessageString | multiLine"
></p>

<p>
  <a class="more" (click)="onClick()" *ngIf="!isOpen">Read More...</a>
</p>
